var heading_default = {
  "fontElementMap": "nGY2x",
  "elementSpacing": "bgK6K",
  "headerOne": "_09ssg bgK6K",
  "headerTwo": "_9GYfw bgK6K",
  "headerThree": "FB9A- bgK6K",
  "headerFour": "_5O1wc bgK6K",
  "headerFive": "klDhb bgK6K",
  "headerSix": "IACkb bgK6K",
  "child": "Ji5Hg"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
